var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntermediate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.363,
    height: 29.957,
    viewBox: "0 0 17.363 29.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7071",
    "data-name": "Group 7071",
    transform: "translate(-26.712 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18949",
    "data-name": "Path 18949",
    d: "M27.783,58.089a.967.967,0,0,1,.2,1.12l-.249.5a2.165,2.165,0,0,0,.059,2.04,2.117,2.117,0,0,0,1.717,1.072l.554.033a.938.938,0,0,1,.861.731l.128.546a2.135,2.135,0,0,0,1.341,1.524,2.1,2.1,0,0,0,2-.3l.445-.335a.939.939,0,0,1,1.124,0l.445.336a2.1,2.1,0,0,0,2,.3,2.136,2.136,0,0,0,1.341-1.524l.128-.546a.939.939,0,0,1,.861-.731l.554-.033A2.116,2.116,0,0,0,43,61.751a2.165,2.165,0,0,0,.059-2.04l-.249-.5a.967.967,0,0,1,.2-1.12l.4-.386a2.162,2.162,0,0,0-.617-3.538l-.51-.223a.96.96,0,0,1-.562-.985l.064-.558a2.157,2.157,0,0,0-.745-1.9,2.1,2.1,0,0,0-1.976-.413l-.532.161a.931.931,0,0,1-1.057-.389l-.305-.469a2.112,2.112,0,0,0-3.551,0l-.305.469a.942.942,0,0,1-1.057.389l-.532-.161a2.1,2.1,0,0,0-1.976.413A2.157,2.157,0,0,0,29,52.4l.064.558a.96.96,0,0,1-.562.985l-.51.223a2.162,2.162,0,0,0-.617,3.538Zm7.61-7.3a6.523,6.523,0,1,1-6.447,6.522,6.523,6.523,0,0,1,6.447-6.522Z",
    transform: "translate(0 -30.831)",
    fill: "#ffe87a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18950",
    "data-name": "Path 18950",
    d: "M41.144,68.622A5.325,5.325,0,1,0,35.881,63.3,5.325,5.325,0,0,0,41.144,68.622Z",
    transform: "translate(-5.751 -36.819)",
    fill: "#fac404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18951",
    "data-name": "Path 18951",
    d: "M35.024,11.156,31.747,5H27.193l5.554,10.433Z",
    transform: "translate(-0.302)",
    fill: "#ff2300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18952",
    "data-name": "Path 18952",
    d: "M48.554,16.618,54.739,5H50.185L44,16.618Z",
    transform: "translate(-10.843)",
    fill: "#ff2300"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntermediate);
export default __webpack_public_path__ + "static/media/intermediate.3d71edf46316f6360ddbe4e55e3f7d63.svg";
export { ForwardRef as ReactComponent };